import "./App.css";
import { Navigate, Route, Routes } from "react-router-dom";
import BusinessAuditPage from "Pages/BusinessAuditPage";
import BusinessEnrolmentPage from "Pages/BusinessEnrolmentPage";
import BusinessUnenrolmentPage from "Pages/BusinessUnenrolmentPage";
import CfoSfoMappingsPage from "Pages/CfoSfoMappingsPage";
import OrderDetailPage from "Pages/OrderDetailPage";
import CreateOrderPage from "./Pages/CreateOrderPage";
import SellerIBAConfigurationPage from "Pages/SellerIBAConfigurationPage";
import HomePage from "Pages/HomePage/homePage";
import { useEnvVarsContext } from "./hooks/useEnvironment";
import { ENVS } from "./utils/constants";

const PAGES = {
  CFO_SFO_MAPPINGS: "cfo-sfo-mappings",
  BUSINESS_AUDIT: "business-audit",
  BUSINESS_ENROLMENT: "business-enrolment",
  BUSINESS_UNENROLMENT: "business-unenrolment",
  ORDER_INFO: "order-info",
  CREATE_ORDER: "create-order",
  SELLER_IBA_CONFIGURATION: "seller-iba-configuration",
};

interface Route {
  readonly page: string;
  readonly name: string;
  readonly element: React.ReactNode;
}

export const ROUTES: Route[] = [
  {
    page: PAGES.CFO_SFO_MAPPINGS,
    name: "CFO SFO Mappings",
    element: <CfoSfoMappingsPage />,
  },
  {
    page: PAGES.BUSINESS_AUDIT,
    name: "Business Audit",
    element: <BusinessAuditPage />,
  },
  {
    page: PAGES.BUSINESS_ENROLMENT,
    name: "Enrol Businesses",
    element: <BusinessEnrolmentPage />,
  },
  {
    page: PAGES.BUSINESS_UNENROLMENT,
    name: "Unenrol Businesses",
    element: <BusinessUnenrolmentPage />,
  },
  {
    page: PAGES.ORDER_INFO,
    name: "Order Info",
    element: <OrderDetailPage />,
  },
];

const NON_PROD_ROUTES: Route[] = [
  {
    page: PAGES.CREATE_ORDER,
    name: "Create IBA Order",
    element: <CreateOrderPage />,
  },
  {
    page: PAGES.SELLER_IBA_CONFIGURATION,
    name: "Configure IBA Seller",
    element: <SellerIBAConfigurationPage />,
  },
];

export const useRoutes = () => {
  const env = useEnvVarsContext();
  const isProduction = env?.FRONTEND_DOMAIN.includes(ENVS.PROD);
  return isProduction ? ROUTES : [...ROUTES, ...NON_PROD_ROUTES];
};

export default function AppRoutes() {
  const routes = useRoutes();

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      {routes.map(({ page, element }) => (
        <Route key={page} path={page} element={element} />
      ))}
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
